import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { MoreHorizontalIcon, ChevronRightIcon, TriangleAlertIcon, PlusIcon, MicIcon, SignalIcon, WifiIcon, BatteryFullIcon } from 'lucide-react';
import { PHOTO_MULTISPORT } from './LoisirsDesktopMock';
const EASE = [0.23, 1, 0.32, 1] as const;
export function LoisirsPhoneMock({
  isFR
}: {
  isFR: boolean;
}) {
  const reduce = useReducedMotion();
  const step = (i: number) => reduce ? {} : {
    initial: {
      opacity: 0,
      y: 8
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.3,
      delay: 0.6 + i * 0.28,
      ease: EASE
    }
  };
  return <div className="w-[280px] rounded-[42px] border-[9px] border-[#1C1F2A] bg-white shadow-[0_30px_70px_rgba(18,18,40,0.22)] overflow-hidden" role="img" aria-label={isFR ? 'ATNA trouve un camp pour Léa et propose de renouveler sa carte numérique BCITI avant l’inscription.' : 'ATNA finds a camp for Léa and offers to renew her BCITI Digital Card before registration.'} data-id="element-4475" data-mp="2h3t6sxgv4lel">
      {/* Status bar */}
      <div className="flex items-center justify-between px-5 pt-3 pb-1" data-id="element-4476" data-mp="37ie1orfwo5ba">
        <span className="font-sans text-[11px] font-semibold text-[#121212]" data-id="element-4477" data-mp="3l9asqdu6oeg8">9:41</span>
        <span className="flex items-center gap-1 text-[#121212]" data-id="element-4478" data-mp="3giawzbwsw2fb">
          <SignalIcon className="w-3 h-3" data-id="element-4479" data-mp="3ggpyxcba21cp" />
          <WifiIcon className="w-3 h-3" data-id="element-4480" data-mp="3v6fguj7lajzo" />
          <BatteryFullIcon className="w-3.5 h-3.5" data-id="element-4481" data-mp="3v5duhil4ib2n" />
        </span>
      </div>

      {/* ATNA header */}
      <div className="flex items-center gap-2.5 px-4 py-2.5 border-b border-[#F0F1F5]" data-id="element-4482" data-mp="3q7kputzgxp4h">
        <span className="w-7 h-7 rounded-full border-[3px] border-[#4F46E5]" data-id="element-4483" data-mp="81pk3k11sp6x" />
        <span className="flex-1" data-id="element-4484" data-mp="347jcgx6pga0">
          <span className="block font-sans text-[12.5px] font-semibold text-[#121212] leading-tight" data-id="element-4485" data-mp="33xvozzm3l7h">ATNA</span>
          <span className="block font-sans text-[10px] text-[#5B6478]" data-id="element-4486" data-mp="29vfer8f0mbql">
            {isFR ? 'Assistant loisirs' : 'Recreation assistant'}
          </span>
        </span>
        <MoreHorizontalIcon className="w-4 h-4 text-[#121212]" data-id="element-4487" data-mp="8sxqcf7bl809" />
      </div>

      <div className="px-3.5 pt-3 pb-3 space-y-2.5 bg-white" data-id="element-4488" data-mp="dpo8d82oqdob">
        {/* User message */}
        <motion.div {...step(0)} className="ml-auto max-w-[80%] rounded-2xl rounded-br-md bg-[#EEF0FE] px-3 py-2" data-id="element-4489" data-mp="ipats4so3087">
          <p className="font-sans text-[11px] text-[#3730A3] leading-snug" data-id="element-4490" data-mp="ms78vlj00e7e">
            {isFR ? 'Je cherche un camp pour Léa cet été.' : 'I’m looking for a camp for Léa this summer.'}
          </p>
        </motion.div>

        {/* ATNA response */}
        <motion.div {...step(1)} className="max-w-[88%] rounded-2xl rounded-bl-md bg-[#F5F6F8] px-3 py-2" data-id="element-4491" data-mp="wmz6uqght32p">
          <p className="font-sans text-[11px] text-[#121212] leading-snug" data-id="element-4492" data-mp="16f534cds26np">
            {isFR ? 'J’ai trouvé 3 options adaptées à son âge. Le camp multisport commence le 6 juillet.' : 'I found 3 options suited to her age. The Multisport camp starts on July 6.'}
          </p>
        </motion.div>

        {/* Recommendation */}
        <motion.div {...step(2)} className="flex items-center gap-2.5 rounded-xl border border-[#ECEEF2] bg-white p-1.5 shadow-[0_4px_12px_rgba(18,18,40,0.05)]" data-id="element-4493" data-mp="2zzf4v1pxr8ug">
          <img src={PHOTO_MULTISPORT} alt="" className="w-14 h-12 rounded-lg object-cover" data-id="element-4494" data-mp="2qxyyd528rqvi" />
          <span className="flex-1 min-w-0" data-id="element-4495" data-mp="2lze5jqpbk9h3">
            <span className="block font-sans text-[11px] font-semibold text-[#121212]" data-id="element-4496" data-mp="2m0ff1qqosnwp">
              {isFR ? 'Camp multisport' : 'Multisport camp'}
            </span>
            <span className="block font-sans text-[9.5px] text-[#5B6478]" data-id="element-4497" data-mp="3en9zworf1pap">{isFR ? '5 à 12 ans' : 'Ages 5 to 12'}</span>
            <span className="block font-sans text-[9.5px] text-[#5B6478]" data-id="element-4498" data-mp="39txbaemqlihy">
              {isFR ? 'Du 6 juillet au 14 août 2026' : 'July 6 to Aug 14, 2026'}
            </span>
          </span>
          <ChevronRightIcon className="w-3.5 h-3.5 text-[#9AA0AE] mr-1" data-id="element-4499" data-mp="689kovd9yb4e" />
        </motion.div>

        {/* Proactive alert */}
        <motion.div {...step(3)} className="rounded-xl border border-[#F5E3B8] bg-[#FFF9EC] px-3 py-2.5" data-id="element-4500" data-mp="3h63db1b5cbm4">
          <p className="flex gap-2 font-sans text-[10.5px] text-[#9A6A0B] leading-snug" data-id="element-4501" data-mp="3m4y70yanjkl0">
            <TriangleAlertIcon className="w-3.5 h-3.5 shrink-0 mt-px text-[#E3A008]" strokeWidth={2.2} data-id="element-4502" data-mp="385ezo7po0d9r" />
            <span data-id="element-4503" data-mp="3d48d604yc49x">
              {isFR ? 'Sa carte numérique BCITI expire avant l’ouverture des inscriptions.' : 'Her BCITI Digital Card expires before registration opens.'}
              <span className="block font-semibold text-[#121212] mt-1" data-id="element-4504" data-mp="8q1rpgqxoz4f">
                {isFR ? 'Je peux vous accompagner pour la renouveler maintenant.' : 'I can help you renew it right now.'}
              </span>
            </span>
          </p>
        </motion.div>

        <motion.div {...step(4)} className="space-y-1.5" data-id="element-4505" data-mp="nn0w6vqhobuo">
          <span className="block rounded-full bg-[#4F46E5] py-2 text-center font-sans text-[11px] font-medium text-white" data-id="element-4506" data-mp="nlhi9bsb2cw2">
            {isFR ? 'Renouveler la carte numérique' : 'Renew the Digital Card'}
          </span>
          <span className="block rounded-full border border-[#E4E6EC] bg-white py-2 text-center font-sans text-[11px] font-medium text-[#4F46E5]" data-id="element-4507" data-mp="xrhb9mw59oxf">
            {isFR ? 'Poursuivre l’inscription' : 'Continue with registration'}
          </span>
        </motion.div>
      </div>

      {/* Composer */}
      <div className="flex items-center gap-2 px-3.5 pb-5 pt-1" data-id="element-4508" data-mp="iu8j4qz0oh4n">
        <PlusIcon className="w-4 h-4 text-[#121212]" data-id="element-4509" data-mp="iui9ifnz4qav" />
        <span className="flex-1 flex items-center justify-between rounded-full border border-[#E4E6EC] px-3 py-2" data-id="element-4510" data-mp="et505vloa4z7">
          <span className="font-sans text-[10px] text-[#9AA0AE]" data-id="element-4511" data-mp="stfsl32mrrmh">
            {isFR ? 'Posez une question à ATNA…' : 'Ask ATNA a question…'}
          </span>
          <MicIcon className="w-3.5 h-3.5 text-[#121212]" data-id="element-4512" data-mp="247l0u89vmnnm" />
        </span>
      </div>
    </div>;
}